import React from 'react';

const PrivacyPolicy: React.FC = () => {
    return (
        <div style={{
            maxWidth: '800px',
            margin: '0 auto',
            padding: '20px',
            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
            lineHeight: '1.6',
            color: '#333'
        }}>

            <h1 style={{ color: '#2c3e50', marginBottom: '30px' }}>Privacy Policy</h1>

            <p style={{ marginBottom: '20px' }}>
                <strong>Effective Date:</strong> December 24, 2024
            </p>

            <section style={{ marginBottom: '30px' }}>
                <h2 style={{ color: '#34495e', borderBottom: '2px solid #3498db', paddingBottom: '10px' }}>
                    1. Information We Collect
                </h2>

                <h3 style={{ color: '#2980b9', marginTop: '20px' }}>Game Progress and Statistics</h3>
                <p>To provide personalized puzzle experiences and track your progress, we collect:</p>
                <ul>
                    <li>Puzzle completion times and scores</li>
                    <li>Game difficulty preferences and settings</li>
                    <li>Progress tracking and achievement data</li>
                    <li>Subscription status and purchase history</li>
                </ul>

                <h3 style={{ color: '#2980b9', marginTop: '20px' }}>Device and Technical Information</h3>
                <p>We automatically collect technical information to ensure app functionality:</p>
                <ul>
                    <li>Device type, model, and operating system version</li>
                    <li>App version and usage analytics</li>
                    <li>Crash reports and error logs</li>
                    <li>General location (country/region) for localization</li>
                </ul>

                <h3 style={{ color: '#2980b9', marginTop: '20px' }}>Subscription Information</h3>
                <p>For premium features and subscriptions, we process:</p>
                <ul>
                    <li>Subscription tier and renewal status</li>
                    <li>Purchase receipts and transaction IDs</li>
                    <li>Billing cycle and payment method (handled by Apple/Google)</li>
                </ul>
            </section>

            <section style={{ marginBottom: '30px' }}>
                <h2 style={{ color: '#34495e', borderBottom: '2px solid #3498db', paddingBottom: '10px' }}>
                    2. How We Use Your Information
                </h2>
                <ul>
                    <li><strong>Game Experience:</strong> To provide personalized puzzle difficulty and track your progress</li>
                    <li><strong>Subscription Management:</strong> To manage premium features and subscription benefits</li>
                    <li><strong>App Improvement:</strong> To analyze usage patterns and improve puzzle quality</li>
                    <li><strong>Technical Support:</strong> To troubleshoot issues and provide customer support</li>
                    <li><strong>Performance:</strong> To optimize app performance and fix bugs</li>
                </ul>
            </section>

            <section style={{ marginBottom: '30px' }}>
                <h2 style={{ color: '#34495e', borderBottom: '2px solid #3498db', paddingBottom: '10px' }}>
                    3. Information Sharing and Disclosure
                </h2>
                <p>We respect your privacy and do not sell or rent your personal information. We may share limited information only in these circumstances:</p>
                <ul>
                    <li><strong>Service Providers:</strong> With trusted third-party services that help us operate our apps (such as analytics providers and cloud storage)</li>
                    <li><strong>App Store Platforms:</strong> Purchase and subscription data is processed by Apple App Store and Google Play Store according to their policies</li>
                    <li><strong>Legal Requirements:</strong> When required by law, regulation, or to protect our rights and users</li>
                    <li><strong>Business Transfers:</strong> In the event of a merger, acquisition, or sale of assets (users will be notified)</li>
                </ul>
            </section>

            <section style={{ marginBottom: '30px' }}>
                <h2 style={{ color: '#34495e', borderBottom: '2px solid #3498db', paddingBottom: '10px' }}>
                    4. Data Storage and Security
                </h2>
                <ul>
                    <li><strong>Local Storage:</strong> Game progress and settings are primarily stored locally on your device</li>
                    <li><strong>Cloud Backup:</strong> Progress may be backed up to iCloud or Google Drive for device synchronization</li>
                    <li><strong>Data Retention:</strong> Game data is retained until you uninstall the app or request deletion</li>
                    <li><strong>Security Measures:</strong> We implement appropriate technical and organizational measures to protect your data</li>
                </ul>
            </section>

            <section style={{ marginBottom: '30px' }}>
                <h2 style={{ color: '#34495e', borderBottom: '2px solid #3498db', paddingBottom: '10px' }}>
                    5. Your Rights and Choices
                </h2>
                <ul>
                    <li><strong>Data Access:</strong> You can view your game statistics and progress within the app settings</li>
                    <li><strong>Data Deletion:</strong> You can reset your progress or request data deletion by contacting us</li>
                    <li><strong>Subscription Management:</strong> You can manage subscriptions through your Apple ID or Google Play account settings</li>
                    <li><strong>Analytics Opt-out:</strong> You can disable analytics tracking in your device's privacy settings</li>
                </ul>
            </section>

            <section style={{ marginBottom: '30px' }}>
                <h2 style={{ color: '#34495e', borderBottom: '2px solid #3498db', paddingBottom: '10px' }}>
                    6. Subscription Terms
                </h2>

                <h3 style={{ color: '#2980b9', marginTop: '20px' }}>King of Sudoku Premium</h3>
                <ul>
                    <li><strong>Subscription Title:</strong> King of Sudoku Premium Subscription</li>
                    <li><strong>Length:</strong> Monthly ($2.99/month) or Annual ($19.99/year)</li>
                    <li><strong>Features:</strong> Unlimited puzzles, advanced difficulty levels, hint system, and ad-free experience</li>
                    <li><strong>Auto-renewal:</strong> Subscriptions automatically renew unless canceled 24 hours before the current period ends</li>
                </ul>

                <h3 style={{ color: '#2980b9', marginTop: '20px' }}>King of Words Premium</h3>
                <ul>
                    <li><strong>Subscription Title:</strong> King of Words Premium Subscription</li>
                    <li><strong>Length:</strong> Monthly ($2.99/month) or Annual ($19.99/year)</li>
                    <li><strong>Features:</strong> Unlimited word puzzles, bonus levels, vocabulary trainer, and ad-free experience</li>
                    <li><strong>Auto-renewal:</strong> Subscriptions automatically renew unless canceled 24 hours before the current period ends</li>
                </ul>

                <p style={{ marginTop: '15px' }}>
                    <strong>Payment:</strong> Payment will be charged to your Apple ID or Google Play account upon purchase confirmation.
                    You can manage and cancel subscriptions in your account settings on your device.
                </p>
            </section>

            <section style={{ marginBottom: '30px' }}>
                <h2 style={{ color: '#34495e', borderBottom: '2px solid #3498db', paddingBottom: '10px' }}>
                    7. Children's Privacy
                </h2>
                <p>Our apps are designed to be family-friendly and suitable for users of all ages. We do not knowingly collect personal information from children under 13 without parental consent. If you believe we have collected information from a child under 13, please contact us immediately.</p>
            </section>

            <section style={{ marginBottom: '30px' }}>
                <h2 style={{ color: '#34495e', borderBottom: '2px solid #3498db', paddingBottom: '10px' }}>
                    8. Third-Party Services
                </h2>
                <p>Our apps may integrate with third-party services for analytics, advertising, and app store functionality. These services have their own privacy policies:</p>
                <ul>
                    <li><strong>Apple App Store:</strong> <a href="https://www.apple.com/privacy/" target="_blank" rel="noopener noreferrer" style={{ color: '#3498db' }}>Apple Privacy Policy</a></li>
                    <li><strong>Google Play Store:</strong> <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" style={{ color: '#3498db' }}>Google Privacy Policy</a></li>
                    <li><strong>Analytics Services:</strong> We may use analytics to improve app performance (you can opt out in device settings)</li>
                </ul>
            </section>

            <section style={{ marginBottom: '30px' }}>
                <h2 style={{ color: '#34495e', borderBottom: '2px solid #3498db', paddingBottom: '10px' }}>
                    9. Updates to This Policy
                </h2>
                <p>We may update this Privacy Policy periodically to reflect changes in our practices or for legal reasons. When we make significant changes, we will notify you through the app or by updating the "Effective Date" at the top of this policy. Continued use of our apps after changes indicates acceptance of the updated policy.</p>
            </section>

            <section style={{ marginBottom: '30px' }}>
                <h2 style={{ color: '#34495e', borderBottom: '2px solid #3498db', paddingBottom: '10px' }}>
                    10. Contact Information
                </h2>
                <p>If you have any questions about this Privacy Policy, our data practices, or your subscription, please contact us:</p>
                <p>
                    <strong>Email:</strong> <a href="mailto:privacy@gamegarden.co" style={{ color: '#3498db' }}>privacy@gamegarden.co</a><br/>
                    <strong>Support:</strong> <a href="mailto:support@gamegarden.co" style={{ color: '#3498db' }}>support@gamegarden.co</a><br/>
                    <strong>Website:</strong> <a href="https://gamegarden.co" target="_blank" rel="noopener noreferrer" style={{ color: '#3498db' }}>https://gamegarden.co</a>
                </p>
            </section>

            <div style={{
                marginTop: '40px',
                padding: '20px',
                backgroundColor: '#ecf0f1',
                borderRadius: '5px',
                textAlign: 'center'
            }}>
                <p style={{ margin: '0', color: '#7f8c8d' }}>
                    This Privacy Policy applies to King of Sudoku and King of Words applications.<br/>
                    Last updated: December 24, 2024
                </p>
            </div>
        </div>
    );
};

export default PrivacyPolicy;